"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _rmaNumber = require("@/api/rma-number.api");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    UploadExcel: _index.default
  },
  data: function data() {
    return {
      form: {
        rmaNumber: null
      },
      rules: {
        rmaNumber: {
          required: true,
          trigger: "submit",
          message: "Required"
        }
      },
      visible: false,
      data: [],
      loadingImport: false
    };
  },
  methods: {
    handleImport: function handleImport() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var rmaNumbers;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$refs.form.validate();
            case 2:
              rmaNumbers = _this.data.map(function (e) {
                return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                  rmaNumber: _this.form.rmaNumber
                });
              });
              _this.loadingImport = true;
              _context.prev = 4;
              _context.next = 7;
              return _rmaNumber.rmaNumberApi.create({
                rmaNumbers: rmaNumbers
              });
            case 7:
              _this.visible = false;
              _this.$emit("submit:ok");
              _this.$notify.success({
                title: "Import",
                message: "Successfully"
              });
            case 10:
              _context.prev = 10;
              _this.loadingImport = false;
              return _context.finish(10);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4,, 10, 13]]);
      }))();
    },
    handleSuccess: function handleSuccess(_ref) {
      var results = _ref.results,
        header = _ref.header;
      console.log("handleSuccess", results);
      var data = [];
      var _iterator = (0, _createForOfIteratorHelper2.default)(results),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          data.push({
            esn: item["ESN"],
            retailerName: item["RETAILER_NAME"],
            poNumber: item["PO_NUMBER"],
            orderNumber: item["ORDER_NUMBER"],
            invoiceNumber: item["INVOICE_NUMBER"],
            replacementEsn: item["REPLACEMENT_ESN"],
            isEligible: item["RMA_ELIGIBLE"] == "YES"
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.data = data;
      console.log("data import ne", this.data);
    },
    handleOpen: function handleOpen() {
      this.visible = true;
      this.data = [];
      this.form = {};
    }
  }
};